export const FORM_LOCALIZATION = {
  en: {
    required: 'The field "{fieldName}" is required.'
  },
  de: {
    required: 'Das Feld "{fieldName}" ist ein Pflichtfeld.'
  },
  sv: {
    required: 'Fältet "{fieldName}" är obligatoriskt.'
  },
  nl: {
    required: 'Het veld "{fieldName}" is verplicht.'
  },
  it: {
    required: 'Il campo "{fieldName}" è obbligatorio.'
  },
  hu: {
    required: 'A(z) "{fieldName}" mező kitöltése kötelező.'
  },
  da: {
    required: 'Feltet "{fieldName}" er obligatorisk.'
  },
  fr: {
    required: 'Le champ "{fieldName}" est obligatoire.'
  },
  es: {
    required: 'El campo "{fieldName}" es obligatorio.'
  },
  pl: {
    required: 'Pole "{fieldName}" jest wymagane.'
  },
  ro: {
    required: 'Câmpul "{fieldName}" este obligatoriu.'
  },
  hr: {
    required: 'Polje "{fieldName}" je obavezno.'
  },
  cs: {
    required: 'Pole "{fieldName}" je povinné.'
  },
  sl: {
    required: 'Polje "{fieldName}" je obvezno.'
  }
};
